/**
 * Clamps a number between a minimum and maximum value.
 *
 * If the provided value is outside of the specified range, the closest boundary of the range will be returned.
 *
 * If the provided value is `undefined` or `null` the minimum value will be returned.
 */
export function clamp(value: number | null | undefined, min: number, max: number) {
  return typeof value === "number" ? Math.min(Math.max(value, min), max) : min;
}
